import script from "./EditableTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditableTable.vue?vue&type=script&lang=ts&setup=true"

import "./EditableTable.vue?vue&type=style&index=0&id=a2ef535c&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2ef535c"]])

export default __exports__